'use client';

import Page from '@organisms/Page/Page';
import useCmsPage from '@hooks/useCmsPage';
import cmsLabels from '@constants/cmsLabels';

const label = cmsLabels.STORE_SEARCH;

const StoreSearchClient = () => {
  const { cmsPage } = useCmsPage(label);

  return <Page cmsPage={cmsPage} />;
};

export default StoreSearchClient;
